import { types } from '../actions/SocialBarActions';
import _ from 'lodash';

let INITIAL_STATE = {
    ssrInit: false,
    width: 0,
    height: 0,
    size: 60,
    margin: 20,
    platformList: [],
    alignment: 'center',
    withWrap: true,
    theme: {},
    viewMode: null,
    updatingComponentSize: false,
    resizingApp: true
};

const HANDLERS = {
    [types.SSR_INIT]: (payload, state) => {
        let newState = _.cloneDeep(state);
        newState.ssrInit = true;
        return newState;
    },

    [types.RESIZE_APP_SUCCESS]: (payload, state) => {
        let newState = {...state, resizingApp: true};
        let {width, height} = payload;

        if (width !== state.width || height !== state.height) {
            newState.width = width;
            newState.height = height;
        }

        return newState;
    },

    [types.RESIZE_APP_ENDING]: (payload, state) => ({...state, resizingApp: false}),

    [types.SET_VIEW_MODE]: (payload, state) => {
        let newState = state;
        let {viewMode} = payload;

        if (viewMode !== state.viewMode) {
            newState = {...state, viewMode};
        }

        return newState;
    },

    [types.SET_PROPS]: (payload, state) => {
        let newState = state;

        for (let prop in payload) {
            if (payload.hasOwnProperty(prop)) {
                if (!_.isEqual(payload[prop], state[prop])) {
                    newState = {...state, ...payload};
                    break;
                }
            }
        }

        return newState;
    },

    [types.UPDATING_COMPONENT_SIZE]: (payload, state) => ({...state, updatingComponentSize: true}),

    [types.UPDATING_COMPONENT_SIZE_END]: (payload, state) => ({...state, updatingComponentSize: false})
};

export default function(state = INITIAL_STATE, action = {}) {
    let handler = HANDLERS[action.type] || (() => state);
    return handler(action.payload, state);
}



// WEBPACK FOOTER //
// ./reducers/SocialBarReducer.js